import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

let counter = 0;

type UseDialogParams = Readonly<{
  buttonTextCancel?: string;
  buttonTextSuccess?: string;
  id?: string;
}>;

type UseDialogResult = Readonly<{
  closeLabel: string;
  descriptionId: string;
  resolvedButtonTextCancel: string;
  resolvedButtonTextSuccess: string;
  titleId: string;
}>;

function useDialog({ buttonTextCancel, buttonTextSuccess, id }: UseDialogParams): UseDialogResult {
  const { t } = useTranslation(['actions']);
  const idRef = useRef<string | null>(null);

  if (idRef.current === null) {
    counter += 1;
    idRef.current = id ?? `dialog-${counter}`;
  }

  return {
    closeLabel: t('actions:Close'),
    descriptionId: `${idRef.current}-description`,
    resolvedButtonTextCancel: buttonTextCancel ?? t('actions:Cancel'),
    resolvedButtonTextSuccess: buttonTextSuccess ?? t('actions:Confirm'),
    titleId: `${idRef.current}-title`,
  };
}

export default useDialog;
